import { styled, SyncIcon } from 'ui';

export const StyledSyncIcon = styled(SyncIcon, {
  shouldForwardProp: (prop) => prop !== 'isSpinning',
})<{ isSpinning?: boolean }>`
  animation: ${({ isSpinning }) =>
    isSpinning ? 'sync-case-spin 1s linear infinite' : 'none'};

  @keyframes sync-case-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
